import React, { Component } from 'react'
import { setSubmitRequestWindow, saveGuestRequest } from '../../action/guestRequest'
import { connect } from 'react-redux'
import { popupOpenClose } from '../../action/action'
import { popupColorSet, guestRequestButton } from '../../JS/setColors'
import { setWebViewAfterKeyBoard } from '../../JS/setWebView'

class submitGuestRequest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            requestList: [],
        }
    }
    componentDidMount() {
        let requestList = []
        if (this.props.guestRequestList.length > 0) {
            this.props.guestRequestList.map((iterator, index) => {
                if (this.props.requestIDList.indexOf(iterator.serviceRequestId) !== -1) {
                    requestList.push(iterator);
                }
            })
            this.setState({ requestList: requestList });
        }
        popupColorSet(this.props.menuColor);
        guestRequestButton(this.props.menuColor);
    }

    onSubmitClick = (event) => {
        let selector
        let selectedGuest, textNote, selectedGuestName;
        let sessionToken = localStorage.getItem('GuestJourneySessionToken');
        event.preventDefault();

        //get the note from text area
        textNote = document.getElementById('guest-request-field').value;
        console.log("textNote", textNote);

        //get selected guest name and its token from the list.
        if (this.props.CheckedInGuest.length > 0) {
            selector = document.getElementById("GuestNameSelector");
            selectedGuestName = selector.options[selector.selectedIndex].value;
            console.log(selectedGuestName);
            if (selectedGuestName !== "0") {
                this.props.CheckedInGuest.map((iterator, index) => {
                    if (iterator.guestName == selectedGuestName) {
                        console.log("guestName", iterator.guestName);
                        selectedGuest = iterator
                    }
                })
            } else {
                this.props.popupOpenClose(true, "Please select the guest name.");
            }
        }

        //API call for Guest request
        if (selectedGuest && sessionToken && this.state.requestList.length > 0) {
            this.props.saveGuestRequest(selectedGuest, sessionToken, this.state.requestList, textNote);
        }
    }
    render() {
        return (
            <div class="overlay">
                <div id="modal-gr" class="overlay-body w-50" >
                    <div class="overlay-close" onClick={() => { this.props.setSubmitRequestWindow(false) }}>
                        <i class="fa fa-close"></i>
                    </div>
                    <select id="GuestNameSelector" name="guests">
                        <option value={
                            this.props.CheckedInGuest.length === 1 ?
                                this.props.CheckedInGuest[0].guestName : "0"
                        }
                        >
                            {
                                this.props.CheckedInGuest.length === 1 ?
                                    this.props.CheckedInGuest[0].guestName : "Please select a guest"
                            }
                        </option>
                        {
                            this.props.CheckedInGuest.length > 0 &&
                                this.props.CheckedInGuest.length !== 1 ?
                                this.props.CheckedInGuest.map((iterator, index) => {
                                    return (
                                        <option value={`${iterator.guestName}`}>{iterator.guestName}</option>
                                    )
                                }) : null
                        }
                    </select>
                    <div class="form-item" style={{ color: "inherit" }}>
                        <label style={{ color: "inherit" }} for="guest-request-field">Comments / Additional requests</label>
                        <textarea
                            id="guest-request-field" rows="5"
                            placeholder="Enter additional comments here"
                            onBlur={(event) => { setWebViewAfterKeyBoard(event) }}
                        >
                        </textarea>
                    </div>
                    <div class="form-controls">
                        <button
                            id="GuestRequestSubmit"
                            class="button w-100"
                            onClick={this.onSubmitClick}
                        >Submit</button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        stringConst: state.store.home.stringConst,
        guestDetails: state.store.home.guestDetails,
        guestRequestList: state.store.guestRequest.guestRequestList,
        CheckedInGuest: state.store.CheckedInGuest,
        requestIDList: state.store.guestRequest.requestIDList,
        menuColor: state.store.home.MenuColor
    }
}
export default connect(
    mapStateToProps,
    {
        setSubmitRequestWindow,
        popupOpenClose,
        saveGuestRequest
    }
)(submitGuestRequest);